import { useAppDispatch } from '@/redux/hooks/useAppDispatch';
import { useAppSelector } from '@/redux/hooks/useAppSelector';
import { loadingUserSelector, userSelector } from '@/redux/user/user.selectors';
import { getSessionValid, updateUser } from '@/redux/user/user.thunks';
import { Button } from '@/shared/Button';
import { Input } from '@/shared/Input';
import React from 'react';
import { orcidEndpointSelector } from '@/redux/oauth/oauth.selectors';
import { closeModal } from '@/redux/modal/modal.slice';

export const ProfileDetailsModal: React.FC = () => {
  const dispatch = useAppDispatch();
  const { userData } = useAppSelector(userSelector);
  const loadingUser = useAppSelector(loadingUserSelector);
  const isPending = loadingUser === 'pending';
  const [data, setData] = React.useState({
    name: userData?.name || '',
    surname: userData?.surname || '',
    password: '',
    email: userData?.email || '',
    orcidId: userData?.orcidId || '',
  });

  const orcidEndpoint = useAppSelector(orcidEndpointSelector);

  const isOrcidAvailable = orcidEndpoint !== undefined;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = e.target;
    setData(prevData => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();
    if (userData) {
      const user = {
        ...userData,
        name: data.name,
        surname: data.surname,
        orcidId: data.orcidId,
        password: data.password,
        email: data.email,
      };
      const status = await dispatch(updateUser(user));
      if (status.meta.requestStatus !== 'rejected') {
        await dispatch(getSessionValid());
        dispatch(closeModal());
      }
    }
  };
  return (
    <div className="w-[600px] border border-t-[#E1E0E6] p-[24px]">
      <form onSubmit={handleSubmit}>
        <label className="mb-5 block text-sm font-semibold" htmlFor="login">
          Login:
          <Input
            type="text"
            name="login"
            id="login"
            placeholder="Your login here.."
            value={userData?.login || ''}
            readOnly
            className="mt-2.5 text-sm font-medium text-font-400"
          />
        </label>
        <label className="text-sm font-semibold" htmlFor="password">
          Password:
          <Input
            type="password"
            name="password"
            id="password"
            placeholder="Your password here.."
            value={data.password}
            onChange={handleChange}
            className="mt-2.5 text-sm font-medium text-font-400"
          />
        </label>
        <label className="text-sm font-semibold" htmlFor="password">
          Name:
          <Input
            type="text"
            name="name"
            id="name"
            value={data.name}
            onChange={handleChange}
            className="mt-2.5 text-sm font-medium text-font-400"
          />
        </label>
        <label className="text-sm font-semibold" htmlFor="password">
          Surname:
          <Input
            type="text"
            name="surname"
            id="surname"
            value={data.surname}
            onChange={handleChange}
            className="mt-2.5 text-sm font-medium text-font-400"
          />
        </label>
        <label className="text-sm font-semibold" htmlFor="password">
          Email:
          <Input
            type="text"
            name="email"
            id="email"
            value={data.email}
            onChange={handleChange}
            className="mt-2.5 text-sm font-medium text-font-400"
          />
        </label>
        {isOrcidAvailable && (
          <label className="text-sm font-semibold" htmlFor="password">
            Orcid ID:
            <Input
              type="text"
              name="orcidId"
              id="orcidId"
              placeholder="Your ORCID ID.."
              value={data.orcidId}
              onChange={handleChange}
              className="mt-2.5 text-sm font-medium text-font-400"
            />
          </label>
        )}
        <Button
          type="submit"
          className="w-full justify-center text-base font-medium"
          disabled={isPending}
        >
          Submit
        </Button>
      </form>
    </div>
  );
};
